import { DragEndEvent } from '@dnd-kit/core'
import { arrayMove, SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable'
import { useContext, useMemo } from 'react'
import { DraggableContext, iconComponent } from 'ui'
import ArtboardTrimmer from '../../components/artboard-trimmer'
import { UgeArtboardContext } from '../../contexts/artboard'
import { UgeLayersContext } from '../../contexts/layers'
import { Toolbar } from '../style'
import Layer from './layer'
import { Label, Layers, LayersList, NoLayers } from './style'

const LayersIcon = iconComponent('layers')

const LayersEditor = () => {
    const { duration } = useContext(UgeArtboardContext)
    const { layers, setLayers } = useContext(UgeLayersContext)
    const reversedLayers = useMemo(() => [...layers].reverse(), [layers])

    const onDragEnd = (e: DragEndEvent) => {
        const { active, over } = e

        if (over?.id && active.id !== over.id) {
            const oldIndex = layers.findIndex((layer) => layer.id === active.id)
            const newIndex = layers.findIndex((layer) => layer.id === over.id)

            setLayers(arrayMove(layers, oldIndex, newIndex))
        }
    }

    return (
        <>
            {duration > 0 && (
                <Toolbar>
                    <ArtboardTrimmer />
                </Toolbar>
            )}
            <Layers>
                <Label>
                    <LayersIcon />
                    Layers
                </Label>
                {layers.length > 0 ? (
                    <DraggableContext activationConstraint={{ distance: 2 }} onDragEnd={onDragEnd}>
                        <SortableContext items={reversedLayers} strategy={verticalListSortingStrategy}>
                            <LayersList>
                                {reversedLayers.map((layer) => (
                                    <Layer
                                        dragDisabled={layers.length < 2}
                                        key={`uge-layer-${layer.id}`}
                                        layer={layer}
                                    />
                                ))}
                            </LayersList>
                        </SortableContext>
                    </DraggableContext>
                ) : (
                    <NoLayers />
                )}
            </Layers>
        </>
    )
}

export default LayersEditor
